import { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import CommandPalette from './components/CommandPalette';
import LoginPage from './pages/LoginPage';
import InviteAcceptPage from './pages/InviteAcceptPage';
import HomePage from './pages/HomePage';
import PageRouter from './pages/PageRouter';
import SearchPage from './pages/SearchPage';
import InboxPage from './pages/InboxPage';
import TrashPage from './pages/TrashPage';
import PublicPage from './pages/PublicPage';
import FormPage from './pages/FormPage';
import ImportPage from './pages/ImportPage';
import WorkspaceLayout from './features/nav/WorkspaceLayout';
import MembersPage from './features/admin/MembersPage';

export default function App() {
  // 커맨드 팔레트 (Cmd+K / Ctrl+K, 사이드바 검색 항목의 rt:open-palette 이벤트)
  const { user } = useAuth();
  const [paletteOpen, setPaletteOpen] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K')) {
        // 비로그인(공개 페이지/로그인 화면)에서는 팔레트가 렌더되지 않으므로
        // preventDefault 없이 무시 — 브라우저 기본 Cmd+K 동작을 가로채지 않는다
        if (!user) return;
        e.preventDefault();
        setPaletteOpen((v) => !v);
      }
    };
    const onOpen = () => setPaletteOpen(true);
    window.addEventListener('keydown', onKey);
    window.addEventListener('rt:open-palette', onOpen);
    return () => {
      window.removeEventListener('keydown', onKey);
      window.removeEventListener('rt:open-palette', onOpen);
    };
  }, [user]);

  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/invite" element={<InviteAcceptPage />} />
        <Route path="/public/:token" element={<PublicPage />} />
        <Route path="/form/:token" element={<FormPage />} />

        {/* 로그인 후: 사이드바 레이아웃 + 중첩 라우트 */}
        <Route
          element={
            <ProtectedRoute>
              <WorkspaceLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<HomePage />} />
          <Route path="page/:pageId" element={<PageRouter />} />
          <Route path="search" element={<SearchPage />} />
          <Route path="inbox" element={<InboxPage />} />
          <Route path="trash" element={<TrashPage />} />
          <Route path="admin/members" element={<MembersPage />} />
          <Route path="import" element={<ImportPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <CommandPalette open={paletteOpen} onClose={() => setPaletteOpen(false)} />
    </>
  );
}
